/* eslint-disable no-param-reassign */
import utils from 'utils/utils';
import Model from 'utils/model';

const Category = function (options) {
    this.attributes = {
        id: 0
    };

    this.initialize(options);
};

Category.prototype = {
    initialize(data) {
        utils.extend(this.attributes, this.parse(data));
    },

    parse(data) {
        if (data.additional) {
            utils.each(data.additional, (value, key) => {
                if (typeof data[key] === 'undefined') {
                    data[key] = value;
                }
            });

            data.images = utils.extend({}, data.images || {}, {
                background: data.background,
                main: data.image,
                logo: data.logo,
                playerLogo: data.playerLogoImage
            });

            data = utils.omit(data, ['additional', 'background', 'image', 'logo', 'playerLogoImage']);
        }

        return data;
    }
};

utils.extend(Category.prototype, Model);

export default Category;
